import React from 'react';
import { motion } from 'framer-motion';
import { MapPinned, MessageCircle, ScanSearch } from 'lucide-react';
const REASONS = [{
  icon: MapPinned,
  title: 'Focused on Vancouver, WA',
  description: 'A local fiber internet dealer with an understanding of the Vancouver-area market.'
}, {
  icon: ScanSearch,
  title: 'Start with availability',
  description: 'We begin with your address, so the conversation is grounded in the options relevant to your home.'
}, {
  icon: MessageCircle,
  title: 'Guidance without the guesswork',
  description: 'Ask questions, discuss your needs, and take the next step with a clearer picture of your fiber options.'
}];
export function WhyChooseUs() {
  return <section id="why-us" className="w-full bg-secondary py-20 lg:py-28" data-id="element-155">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-156">
        <div className="mx-auto max-w-2xl text-center" data-id="element-157">
          <p className="text-sm font-semibold uppercase tracking-wide text-brand-dark" data-id="element-158">
            Why AllStar
          </p>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground sm:text-4xl" data-id="element-159">
            Fiber guidance built around your home
          </h2>
        </div>
        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-160">
          {REASONS.map((reason, index) => {
          const Icon = reason.icon;
          return <motion.div key={reason.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.45,
            delay: index * 0.1,
            ease: [0.22, 1, 0.36, 1]
          }} className="rounded-2xl bg-background p-8 shadow-sm" data-id="element-161">
                <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-ink text-brand" data-id="element-162">
                  <Icon className="h-7 w-7" aria-hidden="true" data-id="element-163" />
                </span>
                <h3 className="mt-6 font-heading text-xl font-semibold text-foreground" data-id="element-164">
                  {reason.title}
                </h3>
                <p className="mt-3 leading-relaxed text-muted-foreground" data-id="element-165">
                  {reason.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}